module.exports = __webpack_public_path__ + "img/bahia_background_1080.deeb544d.svg";